export const apiGet = (url, data={}) => {
    return axios.get(url, {
        params:data
    }).then(response=>{
        return response.data;
    }).catch(error=>{
        return Promise.reject(error.response);
    });
}

export const apiPost = (url, data, params = {}) => {
    return axios.post(url, data, {
        params: params
    }).then(res => {
        return res.data;
    }).catch(error => {
        return Promise.reject(error.response);
    });
}

export const apiPut = (url, data, params = {}) => {
    return axios.put(url, data, {
        params: params
    }).then(res => {
        return res.data;
    }).catch(error => {
        return Promise.reject(error.response);
    });
}

export const apiDelete = (url, data = {}) => {
    return axios.delete(url, data).then(res => {
        return res;
    }).catch(error => {
        return Promise.reject(error.response);
    });
}
